import React, { FC } from 'react';
import {
  IReportBuilderFormik,
  TargetType,
  TGroupingItem,
} from 'domains/ReportBuilder/types';
import ReportSelect from '../ReportSelect';

interface IRenderTargetProps {
  item: TGroupingItem;
  currentKey: string;
  formikKey: keyof IReportBuilderFormik['reportFilters'];
  selectRef?: React.RefObject<any>;
  openedFilter?: string | null;
  setOpenedFilter?: React.Dispatch<React.SetStateAction<string | null>>;
}

export const RenderTarget: FC<IRenderTargetProps> = ({
  item,
  currentKey,
  formikKey,
  selectRef,
  openedFilter,
  setOpenedFilter,
}) => {
  const { data, label } = item;
  const targetOptionsData = data as TargetType[];

  return (
    <ReportSelect
      key={label}
      formikKey={formikKey}
      options={targetOptionsData}
      label={label}
      currentKey={currentKey}
      selectRef={selectRef}
      openedFilter={openedFilter}
      setOpenedFilter={setOpenedFilter}
    />
  );
};
